module.exports = __webpack_public_path__ + "static/media/notification-empty.b26c6134.svg";